var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import * as dayjs from 'dayjs';
import css from './style.pcss';
var RTLLuxAirport = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLLuxAirport, _LitElement);
  function RTLLuxAirport() {
    var _this;
    _classCallCheck(this, RTLLuxAirport);
    _this = _callSuper(this, RTLLuxAirport);
    _this.type = "arrivals";
    _this.location = window.location.origin;
    if (process.env.NODE_ENV == 'development') {
      _this.location = "http://localhost:8080";
      //this.location = "http://10.61.231.42:8080"
    }
    _this.language = 'fr';
    if (window.rtlsites && window.rtlsites.config.language === "en") {
      _this.language = "en";
    }
    _this.flightStatus = {
      "AN": {
        "en": "Cancelled",
        "fr": "Annulé",
        "de": "Abgesagt"
      },
      "DE": {
        "en": "Taken Off",
        "fr": "Décollé",
        "de": "Gestartet"
      },
      "DR": {
        "en": "Diverted",
        "fr": "Diverted",
        "de": "Diverted"
      },
      "EM": {
        "en": "Boarding",
        "fr": "Embarquement",
        "de": "Boarding"
      },
      "EN": {
        "en": "Check-in",
        "fr": "Enregistrement",
        "de": "Check-in"
      },
      "FE": {
        "en": "Check-in Closed",
        "fr": "Enregistrement Terminé",
        "de": "Check-in Geschlossen"
      },
      "PA": {
        "en": "Left",
        "fr": "Left",
        "de": "Left"
      },
      "PR": {
        "en": "Scheduled",
        "fr": "Programmé",
        "de": "Geplant"
      },
      "RE": {
        "en": "Delayed",
        "fr": "Retardé",
        "de": "Verspätet"
      },
      "TE": {
        "en": "Boarding Closed",
        "fr": "Embarquement Terminé",
        "de": "Boarding Geschlossen"
      },
      "AN": {
        "en": "Cancelled",
        "fr": "Annulé",
        "de": "Abgesagt"
      },
      "AP": {
        "en": "Approaching",
        "fr": "Approaching",
        "de": "Im Anflug"
      },
      "AR": {
        "en": "Arrived",
        "fr": "Arrivé",
        "de": "Angekommen"
      },
      "AT": {
        "en": "Landed",
        "fr": "Landed",
        "de": "Gelandet"
      },
      "DE": {
        "en": "Taken Off",
        "fr": "Décollé",
        "de": "Gestartet"
      },
      "PR": {
        "en": "Scheduled",
        "fr": "Programmé",
        "de": "Geplant"
      },
      "RE": {
        "en": "Delayed",
        "fr": "Retardé",
        "de": "Verspätet"
      }
    };
    return _this;
  }
  _createClass(RTLLuxAirport, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLLuxAirport.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "_setType",
    value: function _setType(e, type) {
      this.type = type;
      this.shadowRoot.querySelector('.lux-airport__nav--active').classList.remove('lux-airport__nav--active');
      e.target.classList.add('lux-airport__nav--active');
      this._fetchData();
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      this.apiUrl = "https://api-gate.rtl.lu/luxairport";
      fetch(this.apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      if (this.data == undefined) return html(_t || (_t = _`Loading...`));
      return html(_t2 || (_t2 = _`
            <style>${0}</style>
            <div class="mobility__container">
            <div class="lux-airport__nav-header" align="center">
                <div class="lux-airport__nav lux-airport__nav--active lux-airport__arrivals" @click=${0}>Arrivées</div>
                <div class="lux-airport__nav lux-airport__departures" @click=${0}>Départs</div>
            </div>
            <table class="default-table lux-airport__table">
                <tr class="lux-airport__tr" >
                    <th class="lux-airport__th lux-airport__compagny--display" align="left">Compagnie</th>
                    <th class="lux-airport__th">Numéro</th>
                    <th class="lux-airport__th">${0}</th>
                    <th class="lux-airport__th">Prévu</th>
                    <th class="lux-airport__th">Estimé</th>
                    <th class="lux-airport__th"></th>
                </tr>
                ${0}
            </table>
            </div>
        `), css, function (e) {
        return _this3._setType(e, 'arrivals');
      }, function (e) {
        return _this3._setType(e, 'departures');
      }, this.type == 'arrivals' ? 'Origine' : 'Destination', this.data[this.type].map(function (flight) {
        return html(_t3 || (_t3 = _`
                <tr class="lux-airport__tr lux-airport__tr--grey">
                        <td class="lux-airport__td lux-airport__td--company lux-airport__compagny--display">${0}</td>
                        <td class="lux-airport__td lux-airport__td--number">${0}</td>
                        <td class="lux-airport__td lux-airport__td--destination">${0}</td>
                        <td class="lux-airport__td">${0}</td>
                        <td class="lux-airport__td">${0}</td>
                        <td class="lux-airport__td">${0}</td>
                    </tr>
                `), flight.company, flight.number, flight.whereto, dayjs(flight.addate + ' ' + flight.previewhour).format('HH:mm'), flight.realhour != null ? dayjs(flight.addate + ' ' + flight.realhour).format('HH:mm') : '', flight.state.length > 0 ? _this3.flightStatus[flight.state][_this3.language] : 'Estimé');
      }));
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        type: {
          type: String
        }
      };
    }
  }]);
  return RTLLuxAirport;
}(LitElement);
export { RTLLuxAirport as default };
window.customElements.define('rtl-lux-airport', RTLLuxAirport);